"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _ReactStaticPage = require("../../../../../../react-static/page/ReactStaticPage");

var _Passport = require("./Passport");

var _reactStatic = require("react-static");

var _class;

var PassportPage = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(PassportPage, _Component);

  function PassportPage() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PassportPage.prototype;

  _proto.render = function render() {
    var title = _Passport.ItemTypePassportTitle;
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: title
    }, this.props), _react.default.createElement("p", null, "For the international traveller, your passport is probably the most important item to pack. You will not be getting into foreign countries, or back to your own without one. A passport is also useful as a form of identification."), _react.default.createElement("h2", null, "Taking care"), _react.default.createElement("p", null, "You really don't want you passport getting damaged. This may stop officials from being able to read or scan your passport and cause you major issues when trying to go through immigration. It can also cost you extra money to get a working passport again."), _react.default.createElement("h2", null, "Expensive?"), _react.default.createElement("p", null, "Passport costs vary by country, but can be quite expensive. Passports have a lot of technology aimed to enhance security and provide information about you. Many countries now provide biometric passports (or e-passports) and these include electronic devices (which can also mean your passport may not handle extreme flexing."), _react.default.createElement("h3", null, "Getting Thrifty"), _react.default.createElement("ul", null, _react.default.createElement("li", null, "Some countries will offer different sized passports, which may be cost effective for frequent travellers.")), _react.default.createElement("p", null, "Previously, U.S. passports were able to be extended with new pages, but this option became unavailable January 1, 2016, as has the news page announcing it that was originally here:", " ", _react.default.createElement("i", null, "https:", "//", "travel.state.gov/content/passports/en/news/visa-pages-no-longer-issued.html")), _react.default.createElement("h3", null, "Related Items:"), _react.default.createElement("ul", null, _react.default.createElement("li", null, "Passport holder"), _react.default.createElement("li", null, "Visas - may be required to enter some countries.")));
  };

  return PassportPage;
}(_react.Component)) || _class;

var _default = (0, _reactStatic.withRouteData)(PassportPage);

exports.default = _default;